import React from "react";
import "./experience.css";
import experience from "../../assets/experience.png";
import { Dots } from "react-dot-patterns";
import { Link } from "react-router-dom";
const Experience = () => {
  const scrollHeader = () => {
    window.scroll({ top: 0, behavior: "instant" });
  };
  return (
    <div className="experience-wrapper">
      <div className="dots1">
        <Dots
          col={6}
          row={4}
          size={5}
          rotate={0}
          margin={8}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={10}
          // evenColoumnShift={20}
        />
      </div>
      <div className="dots2">
        <Dots
          col={3}
          row={4}
          size={5}
          rotate={0}
          margin={5}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={-20}
          // evenColoumnShift={20}
        />
      </div>

      <div className="experience-details">
        <div
          className="row align-items-center "
          style={{ justifyContent: "space-between" }}
        >
          <div className="col-12 col-md-6 col-lg-4 order-2 order-md-1 ">
            <div
              className="justify-content-center d-flex"
              style={{ position: "relative", opacity: 1, transform: "none" }}
            >
              <img src={experience} alt="experience" />
              <div className="experience-circle"></div>
              <div className="experience-dots">
                <Dots
                  col={6}
                  row={6}
                  size={7}
                  rotate={20}
                  margin={10}
                  color={"#fff"}
                  item={null}
                  style={{}}
                  evenRowShift={10}
                  // evenColoumnShift={20}
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-8 col-xl-6 order-1 order-md-2">
            <div className="partnership__infos">
              <h2>
                Experience&nbsp;
                <span>Our Solutions</span>
                &nbsp;in Motion
              </h2>
              <p className="fs-lead my-4">
                Discover how our innovative software transforms operations
                through real-time demos, interactive guides, and hands-on
                simulations.
              </p>
              <p className="my-4">
                {/* We are 100% oriented around solving your problems and making you
                successful. If you need skilled people, we make sure they have
                the talent and nature to plug right into your team. When you
                have a job for us, we move mountains to make sure it's done well
                and on time. We pride ourselves on earning your trust, providing
                demonstrable value, and being great at what we do - together. */}
              </p>
              <div className="mt-10x">
                <Link
                  className="link-btn btn link-btn--primary"
                  to="/contact-us"
                  onClick={scrollHeader}
                >
                  <span>Contact Us</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
